<template>
	<v-modal>
		<template v-slot:header>
			<h1>About protocol packs</h1>
		</template>
		<div class="editorial">
			<p class="beta">A protocol pack consists of a set of forms that provide conveyancers with all the fine grained details about a sale property.</p>
		</div>
		<dl class="task-list mt-2">
			<div class="task-list__task">
				<div>
					<dt>TA6</dt>
					<dd class="beta heavy">Property information form</dd>
				</div>
				<dd>
					<dl>
						<dd>
							<button @click.prevent="showMoreInfo('TA6')">
								<span>More about the property information form</span></button>
						</dd>
					</dl>
				</dd>
			</div>
			<div class="task-list__task">
				<div>
					<dt>TA7</dt>
					<dd class="beta heavy">Leasehold information form</dd>
				</div>
				<dd>
					<dl>
						<dd>
							<button @click.prevent="showMoreInfo('TA7')">
								<span>More about the leasehold information form</span></button>
						</dd>
					</dl>
				</dd>
			</div>
			<div class="task-list__task">
				<div>
					<dt>TA10</dt>
					<dd class="beta heavy">Fittings & contents form</dd>
				</div>
				<dd>
					<dl>
						<dd>
							<button @click.prevent="showMoreInfo('TA10')">
								<span>More about the fittings & contents form</span></button>
						</dd>
					</dl>
				</dd>
			</div>
		</dl>
	</v-modal>
</template>
<script>
export default {
	methods: {
		showMoreInfo(form) {
			this.$vmodal.replace({
				component: () => import("./" + form + ".vue"),
				props: {
					showBack: true,
				},
			});
		},
	},
};
</script>
